<template>
  <div class="home">
    
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      src: require("@/assets/images/a4.png"),
      topics_list: [],
    };
  },
  mounted() {},
  methods: {},
};
</script>
